var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('img',{staticClass:"h-[15px]",attrs:{"src":_setup.Logo,"alt":"ReviewsIO Logo"}})
}
var staticRenderFns = []

export { render, staticRenderFns }